// eslint-disable-next-line
/* eslint-disable import/no-cycle */
import Vue from 'vue';
import Vuex from 'vuex';
import home from './home/index';
import order from './order/index';
import statisticOrder from './statistic/order/index';
import statisticSettlement from './statistic/settlement/index';
import statisticSummary from './statistic/summary/index';
import statisticDisplay from './statistic/displayBoard/index';
import userCenter from './userCenter/index';
// import notice from "./notice/index";
import pickGoods from './pickGoods/index';
import manage from './manage/index';
import common from './common/index';
import authManage from './authManage/index';
import qq from './goodManage/qq/index';
import authBind from './authBind/index';
import liveRoom from './coupon/liveRoom/index';
import liveRoomCoupon from './coupon/liveRoomCoupon/index';
import messageCenter from './messageCenter/index';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    common,
    home,
    order,
    statisticOrder,
    statisticSettlement,
    statisticSummary,
    statisticDisplay,
    userCenter,
    // notice,
    pickGoods,
    manage,
    authManage,
    qq,
    authBind,
    liveRoom,
    liveRoomCoupon,
    messageCenter,
  },
});
